import { TabbedItemPage } from './TabbedItemPage';

export const StpManagementPage = () => <TabbedItemPage itemPath="/payroll/stp-management" />;
